import React from 'react';
import MGirthPkl from '../../components/packing_list/MGirthPkl';

const MGirthPklPage = () => {
    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            <MGirthPkl />
        </div>
    );
};

export default MGirthPklPage;
